import { PARENT_PRODUCT, PRODUCT } from '@ahmdigital/constants';

const getDescriptionByProductId = () => ({
  // Packages
  [PARENT_PRODUCT.ESSENTIALS_SILVER_PLUS]: {
    description:
      'Silver hospital cover with sleep studies. You also get accident override & no excess for dependants. Join online.',
    title: 'Silver hospital insurance cover',
  },
  [PARENT_PRODUCT.CORE_SILVER_PLUS]: {
    description:
      'Silver hospital cover with cataracts, joint replacements and sleep studies, with further benefits. You also get accident override & no excess for dependants. Join online.',
    title: 'Silver hospital insurance cover',
  },
  [PARENT_PRODUCT.STARTER_FLEXI_BASIC]: {
    description:
      'Basic hospital and extras for singles and couples, includes accident override and limited medically necessary ambulance. Extras include dental, physio and osteo.',
    title: 'Basic health insurance',
  },
  [PARENT_PRODUCT.ESSENTIALS_FLEXI_BASIC_PLUS]: {
    description:
      'Basic hospital with dental surgery, hernia & appendix & joint reconstructions. Extras includes dental, physio, remedial massage & a separate optical limit. Join now.',
    title: 'Basic health insurance',
  },
  [PARENT_PRODUCT.LITE_FLEXI_BRONZE_PLUS]: {
    description:
      'Hospital cover with a flexi loyalty bonus on eligible extras. Explore our included  extras like dental, health improvements, plus pre & postnatal services.',
    title: 'Bronze health insurance cover',
  },
  [PARENT_PRODUCT.CLASSIC_FLEXI_SILVER_PLUS]: {
    description:
      'Silver services & a flexi limit on included extras, with a separate optical limit. Join now for more hospital benefits ranging from heart & vascular to back, neck & spine, plus more!',
    title: 'Silver hospital & extras cover ',
  },
  [PARENT_PRODUCT.DELUXE_FLEXI_SILVER_PLUS]: {
    description:
      'All the silver benefits and more! Complete with benefits for joint replacements, cataracts, dialysis, plus a loyalty bonus on included extras. Join now.',
    title: 'Silver hospital & extras cover',
  },

  // Hospital
  [PARENT_PRODUCT.AMBULANCE_BASIC]: {
    description: 'Unlimited medically necessary ambulance for you and your family. Join ahm hospital insurance online.',
    title: 'Basic hospital insurance cover',
  },
  [PARENT_PRODUCT.AMBULANCE_AND_ACCIDENT_BASIC]: {
    description:
      'Basic hospital cover with Accident Override that may also override the excess. You also get no excess for dependants. Join online.',
    title: 'Basic hospital cover',
  },
  [PARENT_PRODUCT.CORE_HOSPITAL_BASIC_PLUS]: {
    description:
      'Basic Plus hospital cover with Sleep studies, Dental surgery and Joint reconstructions. You also get no excess for dependants. Join online',
    title: 'Basic Plus hospital cover',
  },
  [PARENT_PRODUCT.BRONZE_NO_FUSS]: {
    description:
      'Your bronze category cover starts here, with some important services. Includes unlimited medically necessary ambulance and accident override just in case.',
    title: 'Bronze hospital cover',
  },
  [PARENT_PRODUCT.BRONZE_PLUS_EVERYDAY]: {
    description:
      'Great value bronze hospital cover, with heaps of important stuff like lung & chest and dental surgery. Plus accident override & no excess for dependants.',
    title: 'Bronze hospital cover',
  },
  [PARENT_PRODUCT.BRONZE_PLUS_LOADED]: {
    description:
      'Comprehensive bronze hospital cover with all the essentials, plus value where it counts. Includes accident override for added peace of mind. Join online.',
    title: 'Bronze hospital cover',
  },
  [PARENT_PRODUCT.ADVANCED_HOSPITAL_GOLD]: {
    description:
      'You can worry less with gold hospital cover. The perfect plan for couples expecting kids, with access to pregnancy & birth services. Join online.',
    title: 'Gold health insurance',
  },

  // Extras
  [PRODUCT.BLACK_50_SAVER_EXTRAS]: {
    description:
      'Get cover for the non-negotiables - like routine dental check-ups  - without spending on things you won’t use. Join now.',
  },
  [PRODUCT.BLACK_60_EXTRAS]: {
    description:
      'Stress less about the little things, like routine dental checks and that new pair of prescription glasses, with 60% back up to your annual limit. Find out more today.',
  },
  [PRODUCT.BLACK_70_EXTRAS]: {
    description:
      'With black 70 extras, we can help with the bill for things like exercise classes to help with medical conditions, and preventative tests too. Join now.',
  },
  [PRODUCT.BLACK_70_BOOST_EXTRAS]: {
    description:
      'With ahm black 70 boost it’s about you, your teeth & your eyes. As well as therapies such as physio and remedial massage to keep you feeling good. Join now.',
  },
  [PRODUCT.LIFESTYLE_EXTRAS]: {
    description:
      'Complete dental including braces, a range of natural therapies and health improvement benefits plus more. You’ll be loving life with plenty of extras goodness.',
  },
  [PRODUCT.FAMILY_EXTRAS]: {
    description:
      'From braces and orthodontics to pre and post natal services. Plus, no family limits means everyone’s got their own limit! The perfect family plan - learn more.',
    title: 'Family private health insurance',
  },
  [PRODUCT.SUPER_EXTRAS]: {
    description:
      'The biggest bunch of extras we’ve got. Plus heaps of routine dental to keep you and your teeth happy.',
  },
  [PRODUCT.VALUE_EXTRAS]: {
    description:
      'A broad range of extras including dental, psychology, counselling, physio, chiro, plus 100% back on optical up to your annual limits. Join online.',
  },

  // Choosable extras
  [PRODUCT.CHOOSABLE_50_TEETH]: {
    description:
      'With ahm choosable 50 you can get cover for your teeth and emergency ambulance, and only ever pay for those extras. Excludes orthodontics',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_EYES]: {
    description:
      'With ahm choosable 60 health cover you can bundle up emergency ambulance, dental and optical health cover options and only ever pay for the extras bundles you’ll use.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_WELLBEING]: {
    description:
      'With ahm choosable 60 health cover you can bundle up emergency ambulance, dental and wellbeing health cover options and only ever pay for the extras bundles you’ll use.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_MUSCLE_BONE]: {
    description:
      'With ahm choosable 60 health cover you can bundle up emergency ambulance, dental, muscle and bone related health cover options and only ever pay for the extras bundles you’ll use.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING]: {
    description:
      'Emergency ambulance, dental, optical and wellbeing related inclusions, with ahm choosable 60 you can start with the base bundle, then choose from there.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_EYES_MUSCLE_BONE]: {
    description:
      'Emergency ambulance, dental, optical, bone and muscle related inclusions, with ahm choosable 60 you can start with the base bundle, then choose from there.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_WELLBEING_MUSCLE_BONE]: {
    description:
      'Emergency ambulance, dental, wellbeing, bone and muscle related inclusions, with ahm choosable 60 you can start with the base bundle, then choose from there.',
    title: 'health insurance extras',
  },
  [PRODUCT.CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE]: {
    description:
      'Emergency ambulance, dental, optical, wellbeing or bone and muscle related inclusions, with ahm choosable 60 you can start with the base bundle, then choose from there.',
    title: 'health insurance extras',
  },
});

export default getDescriptionByProductId;
